import { render } from "./edit-vehicle.vue?vue&type=template&id=6396425b"
import script from "./edit-vehicle.vue?vue&type=script&lang=js"
export * from "./edit-vehicle.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__